import classnames from 'classnames';

import CanvasWaterDropsLoader from './CanvasWaterDropsLoader';

interface ISourceObject {
  src: string;
  type?: string;
}
interface ICategoryBg {
  [index: string]: {
    type: string;
    loop?: boolean;
    darken: boolean;
    cssBg: string;
    sources?: ISourceObject[];
  };
}
interface IProps {
  categoryName: string;
}
// TODO: update keys on each object to match the categories once EDTEU BO is ready
const categoriesBg: ICategoryBg = {
  'The Marriott Bed': {
    type: 'video',
    loop: false,
    darken: true,
    cssBg: 'ctg-lifestyle',
    sources: [
      {
        src: '/videos/ctg-lifestyle.mp4',
        type: 'video/mp4',
      },
      {
        src: '/videos/ctg-lifestyle.webm',
        type: 'video/webm',
      },
      {
        src: '/videos/ctg-lifestyle.ogv',
        type: 'video/ogg',
      },
    ],
  },
  Pillows: {
    type: 'video',
    loop: true,
    darken: false,
    cssBg: 'ctg-artists',
    sources: [
      {
        src: '/videos/ctg-artists.mp4',
        type: 'video/mp4',
      },
    ],
  },
  Fragrance: {
    type: 'image',
    darken: true,
    cssBg: 'ctg-fragrance',
    sources: [
      {
        src: '/images/misc/ctg-fragrance-flickering.gif',
      },
    ],
  },
  Bath: {
    type: 'canvas',
    darken: true,
    cssBg: 'ctg-bath',
  },
};
const CategoryBackground = ({ categoryName }: IProps) => {
  const options = categoriesBg[categoryName];
  if (options?.type === 'video') {
    const { loop, sources, darken, cssBg } = options;
    return (
      <div className={classnames('video-wrapper', { 'darker-bg': darken }, cssBg)}>
        <video autoPlay muted loop={loop} playsInline>
          {sources.map(source => (
            <source src={source.src} key={source.src} type={source.type} />
          ))}
        </video>
      </div>
    );
  }
  if (options?.type === 'image') {
    const { sources, darken, cssBg } = options;
    return (
      <div className={classnames('video-wrapper', { 'darker-bg': darken }, cssBg)}>
        {sources.map(source => (
          <img src={source.src} key={source.src} alt="Category bg" aria-hidden="true" />
        ))}
      </div>
    );
  }
  if (options?.type === 'canvas') {
    const { cssBg } = options;
    return (
      <div className={classnames('video-wrapper', 'absolute', cssBg)}>
        <canvas width="1" height="1" id="canvasContainer" style={{ position: 'absolute' }} />
        <div className="slide" id="slide-2" data-weather="drizzle" />
        <CanvasWaterDropsLoader />
      </div>
    );
  }
  // return a default bg, I'm using this since EDT has this video on various categories
  return (
    <div className="video-wrapper ctg-fauxfurthrows darker-bg">
      <video autoPlay muted playsInline>
        <source src="/videos/ctg-sleep.mp4" type="video/mp4" />
        <source src="/videos/ctg-sleep.webm" type="video/webm" />
        <source src="/videos/ctg-sleep.ogv" type="video/ogg" />
      </video>
    </div>
  );
};
export default CategoryBackground;
